import { ChevronLeft } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectDecoded } from "src/redux/reducers/authSlice";


const GenericHeader = () => {

  const navigate = useNavigate();

  const decoded = useSelector(selectDecoded);
  const groups = decoded?.["cognito:groups"] ?? [];
  const isAdmin = groups.includes("ADMIN");

  return (
    <div className={`p-3 flex items-center justify-end ${ isAdmin ? "" : "hidden"}`}>
      <button
        className="text-lg flex gap-1 items-center border border-gray-600 bg-slate-300 hover:gray-400 px-3 py-2 rounded-lg shadow-md hover:shadow-gray-600"
        onClick={() => navigate("/admin")}
      >
        <ChevronLeft />
        Home
      </button>
    </div>
  );
}

export default GenericHeader